module.exports = __webpack_public_path__ + "img/eCruise_logo.faf2bfae.png";